<app-loading-screen *ngIf="pageLayoutDataService.loading"></app-loading-screen>
<div *ngIf="!pageLayoutDataService.loading" style="padding: 6px;width:100%;height: 100%;">
    <ng-content select="[slot=body]"></ng-content>
</div>
<!-- 
FLOATING BUTTONS
-->
<ng-content *ngIf="!pageLayoutDataService.loading && pageLayoutDataService.minSupportedWidth>canvasLayoutDataService.width" select="[slot=actions]"></ng-content>